import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations, firebaseAction } from 'vuexfire'


Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        LCData: [{
            id:0,
            name: 'Intro to Blockchain',
            author: 'dacade',
            description: 'This Learning Community will be your entry point into the Blockchain universe. After studying the learning materials and completing the assignments you will get individual feedback on your submissions and be able to learn from the submissions of your peers. This community will help you to understand the fundamental concepts of Blockchain technology and participate in the global debate on this revolutionary technology.',
            authorDescription: 'This learning community was developed as a sample course by the dacade team.',
            price: 9,
            assignmentPoints: 44,
            lCTime: 140,
            certificateThereshold:50,
            introductionText: '<p><i>“Bitcoin will do for value transfer what the Internet did for communication — make it programmable.”</i></br> <b>Balaji Srinivasan</b> </p> <p>Blockchain the underlying technology of the Bitcoin currency is considered by many to be the most important technological innovation since the invention of the Internet. It has the potential to disrupt many industries and to change the way we exchange value, build organisations and even transform how we organize society as whole in a substantial way.</p> <p>One indicator for the world wide interest in this technology are the price gains of over 500,000X that Bitcoin experienced since its inception. <i>“Bitcoin has already proven to be the best investment in all of recorded history by a shocking margin for those who got in at its most early stages.”</i> (<b>Benyu</b>, 2017)</p> <p>Some of the smartest people on this planet are working with and are advocating this technology, which is another good indicator of its enormous potential.</p> <i>“Bitcoin is exciting because it shows how cheap it can be. Bitcoin is better than currency in that you don’t have to be physically in the same place and, of course, for large transactions, currency can get pretty inconvenient.”</i> <p><b>Bill Gates</b></p> <p>To be fair Blockchain technology is still in its early stages. But by familiarizing yourself with this technology and working with it today, you will better understand its implications and can contribute to shaping the future of society.</p>',            
            chapter: [{
                chapterId:0,
                chapterName:'What is Bitcoin?',
                chapterShortDescription:'In the first chapter you will learn what Bitcoin is and what problems it solves.',
                chapterTime: 30,
                assignmentPoints: 8
                },{
                chapterId:1,
                chapterName:'How Bitcoin works',
                chapterShortDescription:'In this chapter you will learn how Bitcoin works and what a "blockchain" is.',
                chapterTime: 60,
                assignmentPoints: 16
                },{
                chapterId:2,
                chapterName:'Use cases',
                chapterShortDescription:'Finally we will tell you what other use cases - besides Bitcoin - there are for blockchain technology.',
                chapterTime: 45,
                assignmentPoints: 20
                }
            ]
            }],
            
        ChapterData: [{
            id: 0,
            lCId: 0,
            chapterName: 'What is Bitcoin?',
            chapterDescription: '<p> <i>“I think the internet is going to be one of the major forces for reducing the role of government. The one thing that’s missing but that will soon be developed, is a reliable e-cash.”</i></br> <b>Milton Friedman, 1999</b></br></br> In this chapter you will learn what Bitcoin actually is and why so many people are excited about it. </p>',
            assignment: '1. Imagine you meet a friend that asks you what Bitcoin is. How would you define it in one or two sentences by using the most important terms? (3 Points)<br /><br /> 2. Also tell your friend what advantages Bitcoin has theoretically over traditional currencies. Describe five, each in a short but comprehensible sentence. (5 Points)',
            assignmentDescription: 'Active learning is an important part of dacade. If you want to get the most out of what you’ve learned, then you need to actively recite and test your knowledge. This is crucial for deepening your understanding and for memory retention.',
            assignmentRatingCriteria:['Completeness (8 Points)','Correctness (No Points if incorrect)','50 - 150 Words'],
            assignmentBounty:0.8,
            assignmentPoints:8,
            chapterMaterials:[{
                id:0,
                chapterId: 0,
                materialTitle:'What is Bitcoin?',
                materialSubtitle: 'Youtube Video by WeUseCoins',
                materialTime:2,
                materialDescription: 'This video, also used by bitcoin.org, describes some of the most important characteristics of Bitcoin. In this introduction video, some concepts are simplified.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/Gc2en3nHxA4'
            },{
                id:1,
                chapterId: 0,            
                materialTitle:'Andreas Antonopoulos at Disrupt',
                materialSubtitle: 'Youtube Video by Andreas Antonopoulos',
                materialTime:20,
                materialDescription: 'This is a talk by Andreas Antonopoulos, one of the most important educators in the blockchain space. He explains in detail what bitcoin actually is and what implication it has for society.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/c2CsJ2HMA2I'                        

            }]
        },{
            id: 1,
            lCId: 0,
            chapterName: 'How Bitcoin works',
            chapterDescription: 'Now that you know what Bitcoin is, let’s take a look at how it works. In this chapter, we will explain the so-called Blockchain technology, the key innovation that differentiates Bitcoin from previous digital currencies.<br><br> This chapter might seem technical but is necessary for understanding the full potential of Blockchain technology.',            
            assignment: 'Imagine you meet a programmer who has never heard of Bitcoin or a blockchain. Describe to him or her how Bitcoin works.<br>Use and explain these concepts -  Digital Signatures, Ledger, Decentralisation, Miner, Proof of work, Blockchain.',
            assignmentDescription: 'This assignment focuses on testing your comprehension of the most important concepts and terms of blockchain technology, which are crucial for further studies.',
            assignmentRatingCriteria:['Completeness (13 Points)','Correctness (No Points if incorrect)','Overall quality (3 Points)','200 - 500 Words'],
            assignmentBounty:2,
            assignmentPoints:16,
            chapterMaterials:[{
                id:0,
                chapterId: 1,
                materialTitle:'Explain Bitcoin Like I\'m Five',
                materialSubtitle: 'Medium article by Nik Custodio',
                materialTime:6,
                materialDescription: 'This article is trying to explain how bitcoin works in very simple terms.',
                materialType:'Link',
                materialLink:'https://medium.freecodecamp.org/explain-bitcoin-like-im-five-73b4257ac833'
            },{
                id:1,
                chapterId: 1,            
                materialTitle:'Ever wonder how Bitcoin (and other cryptocurrencies) actually work? (Part 1)',
                materialSubtitle: 'Youtube Video by CuriousInventor',
                materialTime: 9,
                materialDescription: 'This video explains how bitcoin works in technical detail. We split it into three parts so it is easier to digest. The first part introduces the idea of a ledger and explains what digital signatures are. We recommend that you take notes, so it is easier to answer the upcoming assignment.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/bBC-nXj3Ng4?start=1&end=584'                        
            },{
                id:2,
                chapterId: 1,            
                materialTitle:'Ever wonder how Bitcoin (and other cryptocurrencies) actually work? (Part 2)',
                materialSubtitle: 'Youtube Video by 3Blue1Brown',
                materialTime:8,
                materialDescription: 'The second part of this video explaines the concepts of decentralisation, proof of work, hash functions, blocks and the blockchain.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/bBC-nXj3Ng4?start=584&end=1050'  
            },{
                id:3,
                chapterId: 1,            
                materialTitle:'Ever wonder how Bitcoin (and other cryptocurrencies) actually work? (Part 3)',
                materialSubtitle: 'Youtube Video by 3Blue1Brown',
                materialTime:9,
                materialDescription: 'The last part of the video explains what a miner, block reward, and decentralized consensus is. It also shows you why proof of work exists and how it prevents fraudulent transactions.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/bBC-nXj3Ng4?start=1050'                  
                
            }]
        },{
            id: 2,
            lCId: 0,
            chapterName: 'Use cases',
            chapterDescription: '<p><i>“[Bitcoin] is a remarkable cryptographic achievement… The ability to create something which is not duplicable in the digital world has enormous value…Lots of people will build businesses on top of that.”</i></br> <b>Eric Schmidt </b></br></br> Bitcoin is only one application of Blockchain technology. Many people are currently working on Blockchain powered solutions. In this chapter you will learn about a variety of potential use cases of Blockchain technology. </p>',                
            assignment: 'Imagine you meet an investor who wants to fund any Blockchain related project. Come up with your own application which uses Blockchain technology. Present three arguments why your application needs to be using a blockchain.',
            assignmentDescription: 'Let\'s get creative with this assignment. Dacade’s specialty lies in creative assignments with no simple right or wrong answers.',
            assignmentRatingCriteria:['Relevance (12 Points) - 4 points for each argument','Originality (5 Points)','Overall quality (3 Points)','150 - 500 Words'],
            assignmentBounty:1.5,
            assignmentPoints:20,
            chapterMaterials:[{
                id:0,
                chapterId: 2,            
                materialTitle:'The real value of bitcoin and crypto currency technology - The Blockchain explained',
                materialSubtitle: 'Youtube Video by DutchChain',
                materialTime:3,
                materialDescription: 'This video explaines shortly how blockchain technology could change our lives.',
                materialType:'embeded',
                materialLink:'https://www.youtube.com/embed/YIVAluSL9SU?start=165'   
            },{
                id:1,
                chapterId: 2,            
                materialTitle:'The slow death of the firm',
                materialSubtitle: 'Medium article by Nick Tomaino',
                materialTime:6,
                materialDescription: 'In this article Nick Tomaino explains what collaboration may look like in the future and how Blockchain can change the way we work together.',
                materialType:'Link',
                materialLink:'https://thecontrol.co/the-slow-death-of-the-firm-1bd6cc81286b'   
            },{
                id:2,
                chapterId: 2,            
                materialTitle:'Blockchain Tokens and the dawn of the Decentralized Business Model',
                materialSubtitle: 'Medium article by Fred Ehrsam',
                materialTime:9,
                materialDescription: 'This article is written by the founder of what is probably the most valuable exchange - Coinbase (“exchanges” are websites that allows users to buy and sell virtual currencies in exchange for traditional currency). It focuses on the different business models Blockchain technology has already made possible.',                materialType:'Link',
                materialLink:'https://blog.coinbase.com/app-coins-and-the-dawn-of-the-decentralized-business-model-8b8c951e734f'      
            },{
                id:3,
                chapterId: 2,
                materialTitle:'A Letter to Jamie Dimon',
                materialSubtitle: 'Medium article by Adam Ludwin',
                materialTime:18,
                materialDescription: 'This article written by a Blockchain expert makes a strong case for a specific set of Blockchain use cases.',
                materialLink:'https://blog.chain.com/a-letter-to-jamie-dimon-de89d417cb80'  
            },{
                id:4,
                chapterId: 2,            
                materialTitle:'Visions, Part 1: The Value of Blockchain Technology',
                materialSubtitle: 'Blog article by Vitalik Buterin',
                materialTime:32,
                materialDescription: 'This article is written by Vitalik Buterin, the founder of the second most successful cryptocurrency by marketcap - Ethereum.',
                materialType:'Link',
                materialLink:'https://blog.ethereum.org/2015/04/13/visions-part-1-the-value-of-blockchain-technology/',
                materialAdditional:true
            }]
        }],
        currentUser: null,
        currentCourse: null,
        currentChapter: null,
        submission: [],
        reviews: [],
        userCollection: [],
        adminList: [{
            id: 'st6kixudlxd3FRYM5iLEIm4pUNx1'
        }],
    },
    getters: {
        getLCData: state => state.LCData,
        currentUser: state => state.currentUser,
        currentCourse: state => state.currentCourse,
        currentChapter: state => state.currentChapter,
        currentUserEmail: state => state.currentUser.email,
        getCurrentLCData: (state,getters) => (id) => {
           return state.LCData.find(LC => LC.id === getters.currentCourse);
        },
        getCurrentLCData2: (state) => (id) => {
           return state.LCData.find(LC => LC.id === id);
        },
        getCurrentChapterData: (state,getters) => (id) => {
           return state.ChapterData.find(chapter => chapter.id === getters.currentChapter);
        },
        getCurrentChapterData2: (state) => (id) => {
           return state.ChapterData.find(chapter => chapter.id === id);
        },
        getSubmission2: state => state.submission,
        getReviews: state => state.reviews,
        getUserCollection: state => state.userCollection,
        checkUser: (state) => (id) => {
           return state.adminList.find(checkUser => checkUser.id === id);
        },
    },
    mutations: {
        userStatus (state, user) {
            if(user) {
                state.currentUser = user
            } else {
                state.currentUser = null
            }
        },
        courseStatus (state, courseId) {
            state.currentCourse = courseId
        },
        chapterStatus (state, chapterId) {
            state.currentChapter = chapterId
        },
        ...firebaseMutations
    },
    actions: {
        setUser({commit},user) {
            commit('userStatus', user)
        },
        setCourse({commit},courseId) {
            commit('courseStatus', courseId)
        },
        setChapter({commit},chapterId) {
            commit('chapterStatus', chapterId)
        },
        setSubmissionRef: firebaseAction(({ bindFirebaseRef }, { ref }) => {
          bindFirebaseRef('submission', ref)
        }),
        setReviewsRef: firebaseAction(({ bindFirebaseRef }, { ref }) => {
          bindFirebaseRef('reviews', ref)
        }),        
        setUserCollectionRef: firebaseAction(({ bindFirebaseRef }, { ref }) => {
          bindFirebaseRef('userCollection', ref)
        }),  
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js